import KunLoading37 from './src/index'

KunLoading37.install = function (Vue) {
	Vue.component(KunLoading37.name, KunLoading37);
}

export default KunLoading37;
